import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Garantia() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-f360-green text-white relative overflow-hidden" data-id="element-143">
      <div className="absolute inset-0 overflow-hidden opacity-10 pointer-events-none" data-id="element-144">
        <ShieldCheck className="absolute -top-20 -left-20 w-96 h-96" data-id="element-145" />
        <ShieldCheck className="absolute -bottom-20 -right-20 w-96 h-96" data-id="element-146" />
      </div>

      <div className="max-w-[800px] mx-auto text-center relative z-10" data-id="element-147">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white/10 backdrop-blur-sm border border-white/20 p-8 sm:p-12 rounded-3xl" data-id="element-148">
          <ShieldCheck className="w-20 h-20 text-f360-gold mx-auto mb-6" data-id="element-149" />
          <h2 className="text-3xl sm:text-4xl font-extrabold mb-8" data-id="element-150">
            🛡️ Garantía 7 días sin preguntas
          </h2>
          <p className="text-lg sm:text-xl text-white/90 leading-relaxed mb-8" data-id="element-151">
            Abrí los 15 Tomos. Revisá los 6 Bonus. Usá los Ebooks Élite en tu
            próximo entrenamiento. Si no es exactamente lo que esperabas →
          </p>
          <p className="text-2xl sm:text-3xl font-black text-f360-gold mb-10" data-id="element-152">
            100% de devolución. Sin preguntas. Sin formularios. Sin drama.
          </p>
          <div className="inline-block py-2 px-6 rounded-full bg-white text-f360-dark font-black tracking-wide uppercase shadow-lg" data-id="element-153">
            TASA DE DEVOLUCIONES MENOR AL 2%
          </div>
        </motion.div>
      </div>
    </section>;
}